/**
 * Check if a menu item is active based on the current location path
 * and the root path of the menu item
 * This will impact the styling of the menu item
 * @param locationPath
 * @param rootPath
 */
export const checkIsMenuItemActive = (
  locationPath: string,
  rootPath: string | undefined,
) => {
  if (rootPath == null) {
    // No rootPath, the menu item is not a page
    return false;
  } else {
    return locationPath === rootPath || locationPath.startsWith(`${rootPath}/`);
  }
};
